export default "__VITE_ASSET__q4rSBdNM__"